<template>
  <div class="app-sidebar">
    <div class="sidebar-logo" @click="$router.push(homePath)">
      <el-image class="logo-img" :src="logo" fit="contain" @error="onLogoError">
        <div slot="error" class="logo-fallback">管理后台</div>
      </el-image>
      <span v-show="!collapse" class="logo-text">{{ siteTitle }}</span>
    </div>
    <el-scrollbar class="sidebar-scroll">
      <el-menu
        :default-active="activeMenu"
        :collapse="collapse"
        :collapse-transition="false"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        @select="onMenuSelect"
      >
        <sidebar-item
          v-for="item in menuRoutes"
          :key="resolveMenuIndex(item)"
          :item="item"
          :node-key="resolveMenuIndex(item)"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue'
import {
  filterLayoutRoutes,
  navigateMenuItem,
  resolveMenuIndex,
} from '@/layout/utils/menu-nav'

export default {
  name: 'AppSidebar',
  components: { SidebarItem },
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuRoutes: [],
      logo: require('@/assets/icon/application.png'),
      siteTitle: '管理后台',
      homePath: '/',
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    },
  },
  watch: {
    $route() {
      this.loadMenus()
    },
  },
  created() {
    this.loadSiteInfo()
    this.loadMenus()
  },
  methods: {
    resolveMenuIndex,
    loadSiteInfo() {
      const configIndex = sessionStorage.getItem('configIndex')
      if (configIndex) {
        try {
          const cfg = JSON.parse(configIndex)
          if (cfg.site_logo_url) this.logo = cfg.site_logo_url
          if (cfg.site_title) this.siteTitle = cfg.site_title
        } catch (e) {
          /* ignore */
        }
      }
      const userinfo = JSON.parse(sessionStorage.getItem('userinfo') || '{}')
      if (userinfo.shop_name) this.siteTitle = userinfo.shop_name
      else if (userinfo.shop?.title) this.siteTitle = userinfo.shop.title
      else if (userinfo.nickname) this.siteTitle = userinfo.nickname

      const loginPage = sessionStorage.getItem('loginPage')
      if (loginPage === '/adminlogin') this.homePath = '/admin/index'
      else if (loginPage === '/arealogin') this.homePath = '/haowu/manager/overview'
    },
    loadMenus() {
      const text = sessionStorage.getItem('routestext')
      if (!text) {
        this.menuRoutes = []
        return
      }
      try {
        this.menuRoutes = filterLayoutRoutes(JSON.parse(text))
        if (this.menuRoutes[0]?.path) {
          this.homePath = this.menuRoutes[0].path
        }
      } catch (e) {
        this.menuRoutes = []
      }
    },
    onLogoError() {
      this.logo = require('@/assets/icon/application.png')
    },
    onMenuSelect(index) {
      const item = this.findMenuItem(this.menuRoutes, index)
      if (item) navigateMenuItem(item)
    },
    findMenuItem(routes, index) {
      for (const route of routes) {
        if (resolveMenuIndex(route) === index) return route
        if (route.children?.length) {
          const found = this.findMenuItem(route.children, index)
          if (found) return found
        }
      }
      return null
    },
  },
}
</script>

<style scoped lang="less">
.app-sidebar {
  height: 100%;
  background: #304156;
  display: flex;
  flex-direction: column;
}
.sidebar-logo {
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
  background: #2b3a4d;
  overflow: hidden;
  .logo-img {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }
  .logo-fallback {
    font-size: 12px;
    color: #fff;
  }
  .logo-text {
    margin-left: 10px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }
}
.sidebar-scroll {
  flex: 1;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
::v-deep .el-menu {
  border-right: none;
}
::v-deep .el-menu--collapse {
  width: 64px;
}
</style>
